<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-12 11:00:17
-->
<template>
  <div>
    <div class="maintitle">部门最终考核</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini' @keyup.enter.native="searchList"></el-input>
      </el-col>
      <el-button @click="searchList" size='mini'>筛选</el-button>
      <span v-if="votinglist.length>0" style='font-size:12px'><span class="margin-left">{{votinglist.length}}人未完成投票</span><span @click="votingDiv=true" style='cursor:pointer;color:blue'>查看名单</span></span>
    </el-row>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="department" width='100' label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份"></el-table-column>
      <el-table-column label="自评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.selfexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.leaderexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="终评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.excellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="投票结果" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.vote>0" style="color:red">{{scope.row.vote}}条不同意见</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini'>查看</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
            <span v-else v-html='scope.row[item.prop]'></span>
            <!-- <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-else v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table">
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!='final'">{{getBeizhu(item.detail,it.uuid)}}</span>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-select size="mini" v-model="item.excellent" v-if="item.uuid=='final' && assessinfo.status != 9">
              <el-option label='不评' :value='0'></el-option>
              <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
            </el-select>
            <span v-else>{{formatExcellent(item.excellent,1)}}</span>
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <el-input type='textarea' v-model='item.beizhu' v-if="item.uuid=='final' && assessinfo.status != 9"></el-input>
            <span v-else>{{item.beizhu}}</span>
          </td>
        </tr>
      </table>
      <div v-if="voteList.length>0">
        <el-table :data="voteList" row-key="uuid" border>
          <el-table-column prop="name" label="投票人" width="150" align="center"></el-table-column>
          <el-table-column label="投票结果" width="100" align="center">
            <template slot-scope="scope">
              <span v-html="formatVote(scope.row.result)"></span>
            </template>
          </el-table-column>
          <el-table-column label="理由">
            <template slot-scope="scope">
              <span v-html="scope.row.beizhu"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-button @click="submdfy(1)" v-if='canRefuse==1' size='mini' type='info'>暂存</el-button>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
        <el-button @click="refuse" v-if='canRefuse==1' size='mini' type="danger">驳回</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="votingDiv" :show-close="false" :close-on-click-modal="false" title="未投票情况统计">
      <div class="text-left">
        <li v-for='(item,index) in votinglist' :index='index' :key='index' class="margin-bottom">
          <div style="font-weight: bold;">{{item.name}}</div>
          <span v-for="(it,ind) in item.list" :key="ind" style="margin-right:10px;white-space: nowrap;color:gray">{{it}}</span>
        </li>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="votingDiv = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      total: 0,
      page: sessionStorage.getItem('final_dep_page') ? parseInt(sessionStorage.getItem('final_dep_page')) : 1,
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      hasscore: 1,
      crntscope: '',
      excellentlist: [],
      trList: [],
      canRefuse: 0,
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid'),
      voteList: [],
      votinglist:[],
      votingDiv:false
    };
  },
  computed: {
    score() {
      // if(this.hasscore==0) return [];
      let temp = [];
      for (let i in this.info) {
        if (this.info[i]['finaldid'] != 0)
          temp.push({
            id: this.info[i]['finaldid'],
            tiid: parseInt(this.info[i].id),
            proportion: this.info[i].proportion,
            score: this.info[i]['finalscore'] ? parseFloat(this.info[i]['finalscore']) : 0,
            beizhu: this.info[i]['finalbeizhu'] ? this.info[i][['finalbeizhu']] : '',
          })
      }
      return temp;
    },
    alist() {
      if (this.hasscore == 0) return this.info;
      let temp = {
        id: 0,
        title: '合计',
        readonly: 1,
      }
      let shenhe = [];
      for (let item in this.shenheList) {
        shenhe.push(this.shenheList[item].uuid)
        temp[this.shenheList[item].uuid + 'score'] = 0;
      }
      for (let item in this.info) {
        for (let i in shenhe) {
          temp[shenhe[i] + 'score'] += isNaN(parseFloat(this.info[item][shenhe[i] + 'score'])) ? 0 : parseFloat(this.info[item][shenhe[i] + 'score']);
        }
        // temp.finalscore += isNaN(parseFloat(this.info[item].finalscore)) ? 0 : parseFloat(this.info[item].finalscore);
      }
      for (let item in this.assessinfo.detail) {
        if (this.assessinfo.detail[item].uuid == 'final') {
          this.assessinfo.detail[item].score = temp.finalscore
          break;
        }
      }
      return this.info.concat(temp);
    }
  },
  methods: {
    searchList() {
      this.page = 1;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/finalass/getDepList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword
        },
      }).then((res) => {
        this.list = res.data.list.data;
        this.total = res.data.list.total;
        this.votinglist = res.data.votinglist;
      });
    },
    formatVote(result) {
      switch (result) {
        case 0:
          return '不同意';
        case 1:
          return '<span style="color:green">同意</span>';
        default:
          return '<span style="color:red">未投票</span>';
      }
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('final_dep_page', p);
    },
    getBeizhu(item, uuid) {
      for (let i in item) {
        if (i == uuid) {
          return item[i].beizhu
        }
      }
    },
    formatExcellent(e) {
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
    },
    formatExcellentFull(e) {
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    ass(scope) {
      this.crntscope = scope;
      this.$axios({
        url: this.HOST + "/kaohe/finalass/getAssByDep",
        method: "post",
        data: {
          id: scope.row.id
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for (let item in this.assessinfo.detail) {
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.assDiv = true;
          this.crntname = scope.row.name;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList
          this.voteList = res.data.vote;
        }
      });
    },
    refuse() {
      this.$confirm(
          '确定要驳回考核吗？',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/finalass/refuseDep",
          method: "post",
          data: {
            id: this.assessinfo.id,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.assDiv = false;
            this.getlist();
            this.$message({
              type: "info",
              message: "操作成功",
            });
          }
        });
      });
    },
    submdfy(status) {
      this.$axios({
        url: this.HOST + "/kaohe/finalass/saveDepAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          status: status,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.assDiv = false; console.log(this.crntscope);
          this.crntscope.row.excellent = res.data.excellent;
        }
      });
    },
  },
  created: function () {
    this.getlist();
  },
};
</script>